import React, { type ReactNode } from 'react'
import { type Control } from 'react-hook-form'
import { Card, CardContent, Stack, Typography } from '@mui/material'
import { type IStrategyComponent, type ParametersRecord } from '../../../models/strategy/strategy-component-types'
import { prepareFormStrategyParameters } from '../../../utils/view-specific/strategy/strategy-utils'
import StatesDisplay from './states-display'
import StatelessParametersDisplay from './stateless-parameters-display'
import StatefulParametersDisplay from './stateful-parameters-display'

interface StrategyComponentCardProps {
  strategy: IStrategyComponent
  states: Record<string, string[] | any>
  parameters: ParametersRecord
  control: Control<StrategyComponentFormInputs>
}

export type StrategyComponentFormInputs = Record<string, Record<string, string | number | boolean>>

const StrategyComponentCard: React.FC<StrategyComponentCardProps> =
  (props: StrategyComponentCardProps & { children?: ReactNode }) => {
    const { strategy, states, parameters, control } = props
    const name = strategy?.name ?? ''
    const processedParameters = prepareFormStrategyParameters(parameters)

    return (
      <Card variant='outlined' sx={{ borderRadius: '0' }}>
        <CardContent>
          <Stack gap={1}>
            <Typography variant='h6' color='secondary.light'>
              {name}
            </Typography>

            <StatesDisplay states={states} />

            <StatelessParametersDisplay
              processedParameters={processedParameters}
              strategyName={name}
              strategy={strategy}
              control={control}
            />

            <StatefulParametersDisplay
              parameters={parameters}
              processedParameters={processedParameters}
              strategyName={name}
              strategy={strategy}
              control={control}
            />
          </Stack>
        </CardContent>
      </Card>
    )
  }

export default StrategyComponentCard
